<template>
    <div>
        <div class="ap-workspace-head">
            <div class="ap-workspace-label">
                <div class="ap-workspace-label-name">
                    Заявки на визуализацию
                </div>
            </div>
            <div class="ap-workspace-label-btn ap-add-left-margin">
                <label class="ap-search">
                    <input type="text" class="ap-search-input" placeholder="Найти заявку">
                </label>
            </div>
        </div>
        <vue-custom-scrollbar @ps-y-reach-end="scrollReachEnd">
            <div class="ap-workspace-table-container workspace-admin-scroll-part">
                <table class="result-table">
                    <thead>
                    <tr class="head-tr">
                        <th>№</th>
                        <th>Дата поступления</th>
                        <th>Заказчик</th>
                        <th>Город заказчика</th>
                        <th>Изображение</th>
                        <th class="field-edit">Опции</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="body-tr row" v-for="(value, index) in incoming">
                        <td>
                            <span class="table-data">{{index+1}}</span>
                        </td>
                        <td>
                            <span class="table-data">{{dateIntoRu(value.create_date)}}</span>
                        </td>
                        <td>
                            <span v-for="customer in value.customers" class="table-data">{{customer.name}}</span>
                        </td>
                        <td>
                            <span v-for="customer in value.customers" class="table-data">{{customer.city}}</span>
                        </td>
                        <td>
                            <img class="ap-table-img" :src="getFirstImg(value.data_json.photoList)"/>
                        </td>
                        <td>
                            <div class="edit-button-group">
<!--                                <div class="table-svg-button" v-on:click="editRow(value)">-->
<!--                                    <SVGAdminEditRow/>-->
<!--                                </div>-->
                                <div class="table-svg-button" v-on:click="selectUser(value.guid)">
                                    <SVGUserTag/>
                                </div>
                                <div class="table-svg-button" v-on:click="confirm(value)">
                                    <SVGAdminDeleteRow/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div v-if="waitingResponseToIncomingRequest" class="ap-loader-grid">
                    <SpinnerTwo/>
                    <div class="ap-loader-text">
                        Идет загрузка заявок ...
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import SVGAdminEditRow from "../../SVG/SVGAdminEditRow.vue";
    import SVGAdminDeleteRow from "../../SVG/SVGAdminDeleteRow.vue";
    import SVGPlus from "../../SVG/SVGPlus";
    import {urlForFileStorage, urlForStaticVue} from "../../common";
    import SVGSearch from "../../SVG/SVGSearch";
    // import EditProject from "../../Modal/AdminPage/ProjectsPage/EditProject";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import SpinnerTwo from "../../SpinnerTwo";
    import ModalConfirmation from "../../Modal/ModalConfirmation";
    import ModalSelectUser from "../../Modal/AdminPage/ModalSelectUser";
    import SVGUserTag from "../../SVG/SVGUserTag";

    export default {
        name: "AdminIncoming",
        mixins: [urlForStaticVue, urlForFileStorage],
        components: {
            SVGUserTag,
            SpinnerTwo,
            SVGSearch,
            SVGPlus,
            SVGAdminDeleteRow,
            SVGAdminEditRow,
            vueCustomScrollbar
        },
        computed:{
            incoming(){
                return this.$store.getters["adminPanel/incoming/INCOMING_PROJECTS"];
            },
            waitingResponseToIncomingRequest(){
                return this.$store.state.adminPanel.incoming.waitingResponseToIncomingProjectsRequest;
            }
        },
        methods: {
            dateIntoRu(createDate) {
                let date = new Date(createDate).toLocaleString('ru', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });
                return date;
            },
            scrollReachEnd() {
                this.$store.dispatch('adminPanel/incoming/GET_INCOMING_PROJECTS');
            },
            // urlForPhoto(url) {
            //     return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            // },
            getFirstImg(photoList){
                for (let idPhoto in photoList) {
                    return this.urlForFileStorage(photoList[idPhoto].src);
                }
                return this.urlForStatic('img/No_Picture.jpg');
            },
            // editRow(projectData) {
            //     console.log(projectData);
            //     this.$modal.show(EditProject, {projectData}, {
            //         height: 'auto',
            //         pivotY: 0.2,
            //         width: 516,
            //         draggable: true,
            //     });
            // },
            deleteRow(incomingUUID) {
                return () => {this.$store.dispatch('adminPanel/incoming/DELETE_INCOMING', incomingUUID)};
            },
            assign(projectGUID) {
                return async (userId) => {
                    if (userId) {
                        await this.$store.dispatch('adminPanel/incoming/ASSIGN_INCOMING_PROJECT', {
                            projectGUID: projectGUID,
                            userId: userId
                        });
                        this.$emit('close');
                    }
                }
            },
            confirm(incoming) {
                const title = `Удалить заявку заказчика?`
                const text = 'Данная заявка будет безвозвратно удалена, хотите продолжить?';
                this.$modal.show(ModalConfirmation, {title, text, alright: this.deleteRow(incoming.guid)}, {
                    name: 'confirmationModal',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            },
            selectUser(guid) {
                this.$modal.show(ModalSelectUser, {
                    description: 'Выберите одного из пользователей, чтобы назначить его ответственным за выполнение заказа',
                    callback: this.assign(guid)
                }, {
                    name: 'selectUser',
                    height: 'auto',
                    pivotY: 0.2,
                    width: 460,
                    draggable: true,
                });
            }
        },
        mounted() {
            this.$store.dispatch('adminPanel/incoming/GET_INCOMING_PROJECTS');
        }
    }
</script>

<style scoped>

</style>

